import React from 'react';
import { useTranslation } from 'react-i18next';

const ChequePaymentWarningPopup = ({
  setChequePaymentWarning,
  setspayCheckedInvoices,
}) => {
const { t } = useTranslation(); 

  return (
    <div className='!w-[438px] bg-white overflow-hidden pl-[50px] pr-[25px] pt-[52px] py-[48px] relative rounded'>
      <img
        src='images/exit.ca93bf87.svg'
        alt='Exit Logo'
        onClick={() => {
          setChequePaymentWarning(false);
          setspayCheckedInvoices(false);
        }}
        className='!cursor-pointer absolute h-[14px] right-[25px] top-[25px] w-[14px]'
      />
      {/* <div className='flex gap-[10px] items-center mb-[16px]'>
        <img
          src='images/alert-triangle-black.ecfd0e67.svg'
          aria-hidden='true'
          className='inline'
          alt='steper icon'
        />
        <h1 className='font-[700] font-montserrat text-left text-xl'>
          Warning
        </h1>
      </div> */}
      <div className='!font-[400] font-open-sans text-base text-gray-800 text-left'>
        <p className='max-w-[380px]'>
          {/* Cheque payments can only be paid through alternative payment method
          online. */}
          {t("EFTChequeWarning" )}
        </p>
        <div className='flex gap-[28px] items-end justify-end mt-[32px]'>
          <button
            id='close-button'
            tabindex='0'
            className='btn__primary h-[40px] px-[16px] w-fit'
            aria-label='Close'
            type='submit'
            onClick={() => {
              setChequePaymentWarning(false);
              setspayCheckedInvoices(true);
            }}
          >
            {t("Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChequePaymentWarningPopup;
